var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Preloader'),_c('Header'),_c('WelcomeTmp'),_c('Services'),_c('About'),_c('Works'),_c('Footer2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }